import { mainSlider } from '../../components/glide'
import SingleMap from '../../components/single-map'

const init = () => {
  mainSlider()
  SingleMap()
}

export default init
